/* eslint @typescript-eslint/naming-convention: 0 */

import { sendWabunkaGAEvent } from '@/wabunka-src/common/utils/googleAnalytics/googleAnalytics';

export type ClickAddFiltersParams = Record<string, never>;

/**
 * 発火タイミング：Add Filtersボタン押下時
 */
export const sendGAWabunkaClickAddFiltersEvent = () => {
  sendWabunkaGAEvent('click_add_filters', {});
};
